import React, { useState, useEffect, useContext } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify'; // Import toast and ToastContainer
import 'react-toastify/dist/ReactToastify.css'; // Import toast styles
import OrgContext from '../context/OrgContext'; // Adjust the path as needed


const Categories = () => {

    const {activeOrg} = useContext(OrgContext);


    const [categories, setCategories] = useState([]);
    const [newCategory, setNewCategory] = useState({ name: '', image: '' });
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState(''); // State for previewing the image
    const [currentPage, setCurrentPage] = useState(1); // Pagination state
    const itemsPerPage = 5; // Number of items per page
    const [searchQuery, setSearchQuery] = useState(''); // Search query state
    

    useEffect(() => {
        if (activeOrg){
        fetchCategories();
        }
    }, [currentPage, activeOrg]);

    useEffect(() => {
      console.log('Categories state updated:', categories); // Log the current categories whenever the component re-renders
    }, [categories]);

    const fetchCategories = async () => {
        const token = sessionStorage.getItem('token');
        try {
            const response = await axios.get(`${process.env.REACT_APP_SRV}/categories`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    orgid: `${activeOrg?activeOrg._id:''}`
                },
            });
            setCategories(response.data);
        } catch (error) {
            console.error('Error fetching categories:', error);
            toast.error('Error fetching categories');
        }
    };

    const onDrop = async (acceptedFiles) => {
        const token = sessionStorage.getItem('token');
        const formData = new FormData();
        formData.append('image', acceptedFiles[0]);

        try {
            const response = await axios.post(`${process.env.REACT_APP_SRV}/categories/upload`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            setNewCategory({ ...newCategory, image: response.data.imageUrl });
            setPreviewImage(URL.createObjectURL(acceptedFiles[0])); // Set the preview image
            toast.success('Image uploaded successfully');
        } catch (error) {
            console.error('Error uploading image:', error);
            toast.error('Error uploading image');
        }
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        'image/*': ['.jpeg', '.jpg', '.png', '.webp'],
        multiple: false,
    });

    const openDialog = () => {
        setNewCategory({ name: '', image: '' });
        setPreviewImage(''); // Clear preview when adding a new category
        setIsDialogOpen(true);
    };

    const closeDialog = () => {
        setIsDialogOpen(false);
    };

    const handleCreateOrUpdate = async () => {
      const token = sessionStorage.getItem('token');
      try {
        const endpoint = newCategory._id
          ? `${process.env.REACT_APP_SRV}/categories/${newCategory._id}`
          : `${process.env.REACT_APP_SRV}/categories`;
        const method = newCategory._id ? 'put' : 'post';
    
        const response = await axios[method](endpoint, newCategory, {
          headers: {
            Authorization: `Bearer ${token}`,
            orgid: `${activeOrg?activeOrg._id:''}`
          },
        });
    
        const updatedCategory = response.data.category; // Extract the category from the response
        console.log('Updated category:', updatedCategory); // Log the correct updated category
    
        if (newCategory._id) {
          // Updating existing category in the state
          setCategories(prevCategories => {
            const updatedCategories = prevCategories.map(category => 
              category._id === updatedCategory._id ? updatedCategory : category
            );
            console.log('Updated categories array:', updatedCategories); // Log updated categories
            return updatedCategories;
          });
        } else {
          // Adding new category
          setCategories(prevCategories => {
            const newCategoriesArray = [...prevCategories, updatedCategory];
            console.log('New categories array:', newCategoriesArray); // Log the new categories
            return newCategoriesArray;
          });
        }
    
        // Clear the form and close dialog
        setNewCategory({ name: '', image: '' });
        closeDialog();
    
        toast.success(`Category ${newCategory._id ? 'updated' : 'created'} successfully`);
    
      } catch (error) {
        console.error(`Error ${newCategory._id ? 'updating' : 'creating'} category:`, error);
        toast.error(`Error ${newCategory._id ? 'updating' : 'creating'} category`);
      }
    };
    
    
    
    

    const handleDelete = async (id) => {
        const token = sessionStorage.getItem('token');
        try {
            await axios.delete(`${process.env.REACT_APP_SRV}/categories/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    orgid: `${activeOrg?activeOrg._id:''}`
                },
            });
            setCategories(categories.filter(category => category._id !== id));
            toast.success('Category deleted successfully');
        } catch (error) {
            console.error('Error deleting category:', error);
            toast.error('Error deleting category');
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
    };

    // Pagination and search logic
    const filteredCategories = categories.filter(category =>
        category.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredCategories.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <div>
            <ToastContainer /> {/* Toast container for displaying notifications */}
            <div className="mb-4 flex justify-between items-center">
                <input
                    type="text"
                    placeholder="Search categories..."
                    value={searchQuery}
                    onChange={handleSearch}
                    className="px-4 py-2 bg-gray-800 rounded text-white"
                />
                <button onClick={openDialog} className="bg-green-600 px-4 py-2 rounded hover:bg-green-700">
                    Add Category
                </button>
            </div>

            <ul>
                {currentItems.map(category => (
                    <li key={category._id} className="bg-gray-800 p-4 mb-2 rounded flex justify-between items-center">
                        <div>
                            <h3 className="text-xl">{category.name}</h3>
                            {category.image && (
                                <img src={`${process.env.REACT_APP_SRV}${category.image}`} alt={category.name} className="w-16 h-16" />
                            )}
                        </div>
                        <div>
                            <button
                                onClick={() => {
                                    setNewCategory(category);
                                    setIsDialogOpen(true);
                                }}
                                className="bg-blue-600 px-4 py-2 rounded hover:bg-blue-700 mr-2"
                            >
                                Edit
                            </button>
                            <button
                                onClick={() => handleDelete(category._id)}
                                className="bg-red-600 px-4 py-2 rounded hover:bg-red-700"
                            >
                                Delete
                            </button>
                        </div>
                    </li>
                ))}
            </ul>

            {/* Pagination */}
            <div className="flex justify-center mt-4">
                {Array.from({ length: Math.ceil(filteredCategories.length / itemsPerPage) }, (_, i) => (
                    <button
                        key={i}
                        onClick={() => handlePageChange(i + 1)}
                        className={`px-3 py-2 mx-1 rounded ${currentPage === i + 1 ? 'bg-golden' : 'bg-gray-800 hover:bg-gray-700'}`}
                    >
                        {i + 1}
                    </button>
                ))}
            </div>

            {/* Add/Edit Category Dialog */}
            {isDialogOpen && (
                <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center">
                    <div className="bg-gray-800 p-6 rounded-lg">
                        <h3 className="text-xl mb-4">{newCategory._id ? 'Edit Category' : 'Add New Category'}</h3>
                        <input
                            type="text"
                            placeholder="Name"
                            value={newCategory.name}
                            onChange={(e) => setNewCategory({ ...newCategory, name: e.target.value })}
                            className="block w-full mb-2 p-2 bg-gray-700 text-white rounded"
                        />
                        <div {...getRootProps()} className="border-2 border-dashed p-4 text-center mb-4">
                            <input {...getInputProps()} />
                            {isDragActive ? (
                                <p>Drop the files here ...</p>
                            ) : (
                                <p>Drag 'n' drop an image, or click to select one</p>
                            )}
                        </div>

                        {previewImage && (
                            <img src={previewImage} alt="Category Preview" className="w-32 h-32 mb-4" />
                        )}

                        <button onClick={handleCreateOrUpdate} className="bg-green-600 px-4 py-2 rounded hover:bg-green-700">
                            {newCategory._id ? 'Update Category' : 'Create Category'}
                        </button>
                        <button onClick={closeDialog} className="bg-red-600 px-4 py-2 ml-2 rounded hover:bg-red-700">
                            Cancel
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Categories;
